import IAppLogger from '@app/lib/IAppLogger';
import DiagnosticsModule, {
  MetricNames,
  MetricTags,
  OperationNames,
} from '@modules/DiagnosticsModule';
import { audioDevicesState } from '@modules/SoftPhoneModule/audioDevicesState';
import { DeviceInitFailedPayload } from '@modules/SoftPhoneModule/types';
import { webPhoneEventNames } from '@modules/SoftPhoneModule/constants/events';

/**
 * Handles the `webphone:device-initialization-failed` event emitted by the webphone MFE
 * when audio devices cannot be initialized on startup (e.g. permission denied,
 * no microphone found, or the media API is unavailable).
 *
 * Logs the error, reports it to {@link DiagnosticsModule}, increments the error
 * counter metric, and updates {@link audioDevicesState} with the error category.
 */
const handleDeviceInitializationFailed = (
  payload: DeviceInitFailedPayload,
  logger: IAppLogger,
): void => {
  const { errorCategory, errorName, errorMessage } = payload;

  logger.error(webPhoneEventNames.deviceInitializationFailed, {
    errorCategory,
    errorName,
    errorMessage,
  });

  DiagnosticsModule.incrementCounter(MetricNames.ERROR_TOTAL, {
    [MetricTags.OPERATION_NAME]: OperationNames.AUDIO_DEVICE_INIT,
    [MetricTags.ERROR_TYPE]: errorCategory,
  });

  DiagnosticsModule.reportBackgroundError(errorMessage, {
    source: 'softphone',
    priority: 'normal',
  });

  audioDevicesState.audioInputDevices = [];
  audioDevicesState.audioOutputDevices = [];
  audioDevicesState.errorCategory = errorCategory;
  audioDevicesState.isDevicesReady = false;
};

export default handleDeviceInitializationFailed;
